import React from "react";
import { SideMenuItem, SideMenuSpacer } from "../SidemenuItems";
import { Div } from "../../../../components/grid";

export default ({ activeSidemenu }) => (
  <Div>
    <SideMenuItem
      to="/leverandoer-sodavand-kildevand-oel"
      title="Din leverandør af sodavand, kildevand & øl"
      active={activeSidemenu === "Leverandoer"}
      main
    />
    <SideMenuSpacer />
    <SideMenuItem
      title="Sodavand"
      to="/sodavand"
      active={activeSidemenu === "Sodavand"}
    />
    <SideMenuItem
      title="Coca-Cola"
      to="/sodavand/coca-cola"
      active={activeSidemenu === "CocaCola"}
    />
    <SideMenuItem
      title="Frem Sodavand"
      to="/sodavand/frem-sodavand"
      active={activeSidemenu === "FremSodavand"}
    />
    <SideMenuItem
      title="San Pellegrino Sodavand"
      to="/sodavand/san-pellegrino-sodavand"
      active={activeSidemenu === "SanPellegrinoSodavand"}
    />
    <SideMenuItem
      title="Schweppes"
      to="/sodavand/schweppes"
      active={activeSidemenu === "Schweppes"}
    />
    <SideMenuItem
      title="Faxe Kondi"
      to="/sodavand/faxe-kondi"
      active={activeSidemenu === "FaxeKondi"}
    />
    <SideMenuItem
      title="Tuborg Squash"
      to="/sodavand/tuborg-squash"
      active={activeSidemenu === "TuborgSquash"}
    />
    <SideMenuItem
      title="Kinley"
      to="/sodavand/kinley"
      active={activeSidemenu === "Kinley"}
    />
    <SideMenuItem
      title="Pepsi"
      to="/sodavand/pepsi-cola"
      active={activeSidemenu === "Pepsi"}
    />
    <SideMenuItem
      title="Danskvand"
      to="/danskvand"
      active={activeSidemenu === "Danskvand"}
    />
  </Div>
);
